import type { ReactNode } from 'react'

/**
 * The agent's prose seam: an answer the agent wrote (a comment draft, a posted agent comment) is
 * Markdown. Poiesis carries no Markdown parser; a host registers one (Sentinel: its lazily loaded GFM
 * renderer). Without one, the text shows as written. Never used for a person's own comment text.
 */
type RichTextRenderer = (text: string) => ReactNode
let renderer: RichTextRenderer | null = null

export function registerRichText(r: RichTextRenderer) { renderer = r }

export function RichText({ text, className = '' }: { text: string; className?: string }) {
  return renderer
    ? <div data-testid="rich-text" className={`prose prose-sm max-w-none dark:prose-invert break-words ${className}`}>{renderer(text)}</div>
    : <p className={`whitespace-pre-wrap break-words ${className}`}>{text}</p>
}
